import React from 'react';
import styles from './ProjectCard.module.css';
import Button from '../../common/Button/Button';

function ProjectCard({ title, description, imageSrc, detailsLink }) {
  return (
    <div className={styles.projectCard}>
      <div className={styles.imageWrapper}>
        <img src={imageSrc || "/images/logo.jpg"} alt={title} className={styles.projectImage} />
        <div className={styles.overlay}>
          <div className={styles.viewLink}>Découvrir le projet</div>
        </div>
      </div>
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{title}</h3>
        <p className={styles.description}>{description}</p>
        <div className={styles.cardFooter}>
          {detailsLink && (
            <Button to={detailsLink} variant="secondary" className={styles.projectButton}>Voir le projet</Button>
          )}
        </div>
      </div>
    </div>

  );
}

export default ProjectCard;
